import styled from 'styled-components'

export const TabsWrapper = styled.div<TSFixMe>`
  overflow: auto;
  padding: 10px 20px 0;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(153, 153, 189, 0.3);
`

export const Tabs = styled.div<TSFixMe>`
  display: flex;
`

export const Tab = styled.div<TSFixMe>`
  padding: 10px 5px;
  cursor: pointer;
  margin: 0 20px;
  text-decoration: none;
  color: #5d5c70;
  font-size: 15px;

  &.active {
    padding: 10px 5px 7px 5px;
    font-weight: 500;
    border-bottom: 3px solid #80deea;
  }

  :first-child {
    margin: 0 20px 0 0;
  }

  :last-child {
    margin: 0 0 0 20px;
  }
`

export const Actions = styled.div<TSFixMe>`
  display: flex;
  justify-content: flex-start;
  padding: 20px 20px 0;
`

export const Header = styled.div<TSFixMe>`
  padding: 30px 20px;
`

export const Content = styled.div<TSFixMe>`
  padding: 35px 20px;
`
